export const NATIVE_DEEP_LINK_SCHEME = 'casumo:/';
